import * as React from 'react';
import s from './SaleBannerBase.scss';
import classNames from 'classnames';
import { RootStore, withInjectedRootStore } from 'providers';

interface SaleBannerBaseProps {
  className: string;
  rootStore: RootStore;
}

type TSaleBannerBase<T> = React.FC<T> & {
  Icon: React.FC;
  Text: React.FC;
};

const SaleBannerBaseComp: TSaleBannerBase<SaleBannerBaseProps> = ({
  children,
  className,
  rootStore: {
    appStore: { isInSale },
  },
}) => {
  return (
    <div
      className={classNames(s.root, { [s.sale]: isInSale }, className)}
      data-hook='sale-banner'
    >
      {children}
    </div>
  );
};

const SaleBannerIcon: React.FC = ({ children }) => (
  <div className={s.iconWrapper}>{children}</div>
);

const SaleBannerText: React.FC = ({ children }) => (
  <div className={s.discountText}>{children}</div>
);

SaleBannerBaseComp.Icon = SaleBannerIcon;
SaleBannerBaseComp.Text = SaleBannerText;

export const SaleBannerBase: TSaleBannerBase<
  Omit<SaleBannerBaseProps, 'rootStore'>
> = withInjectedRootStore(SaleBannerBaseComp) as any;
